document.addEventListener('DOMContentLoaded', function () {
  /*
  jQuery('.quantity__button--plus').on('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    // Find the input field that is a sibling of the clicked button
    var $input = jQuery(this).siblings('.quantity__input');
    console.log("raw value "+ $input.val()); 
    // Get the current value from the input, convert it to a number
    var currentValue = parseInt($input.val());
    console.log("value: "+ currentValue);
    // Increment the value and set it back to the input field
    $input.val(currentValue + 1);
  });
  */
  jQuery('.image_sliderI').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true,
      centerMode: true,
      variableWidth: false,
      centerPadding: '100px',
      responsive: [
        {
          breakpoint: 768,
          settings: { 
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerPadding: '50px',
            arrows: false
          }
        },
      ],
    });
  });

  jQuery('.image_sliderM').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true,
      centerMode: true,
      variableWidth: false,
      centerPadding: '50px',
      responsive: [
        {
          breakpoint: 768,
          settings: { 
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerPadding: '50px',
            arrows: false
          }
        },
      ],
    });
  });

  jQuery('.video_sliderM').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: { 
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerPadding: '50px',
            arrows: false
          }
        },
      ],
    });
  });

  jQuery('.twocol_image_sliderI').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true,
      centerMode: true,
      variableWidth: false,
      centerPadding: '100px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerPadding: '50px',
            arrows: false
          }
        },
      ],
    });
  });

  jQuery('.logos_slider').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerPadding: '50px',
            arrows: false
          }
        },
      ],
    });
  });

  jQuery('.logos-text_slider').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: true,
      variableWidth: false,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slider.data('mobile-slides-to-show'),
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
            nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>'
          }
        },
      ],
    });
  });

  jQuery('.usps_slider').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      cssEase: 'linear',
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slider.data('mobile-slides-to-show')
          }
        },
      ],
    });
  });

  jQuery('.filterProductList').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      infinite: false,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 2,
            variableWidth: true
          }
        },
      ],
    });
  });
  jQuery(".filterProductList .button").click(function(e){
    console.log(jQuery(this).data("col"));
    jQuery("#"+jQuery(this).data("parent")+" .hFeaturedColProductsW").hide();
    jQuery("#"+jQuery(this).data("col")).show();
    jQuery(".filterProductList .button").removeClass("active").removeClass("pink");
    jQuery(this).addClass("active").addClass("pink");
  });

  jQuery('.product-media-gallery').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: slider.data('desktop-slides-to-show'),
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true,
      centerMode: true,
      variableWidth: false,
      centerPadding: '100px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slider.data('mobile-slides-to-show'),
            centerMode: false,
            infinite: false
          }
        },
      ],
    });
  });

  jQuery('.us-slider').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true
    });
  });

  jQuery('.review-slider').each(function () {
    const slider = jQuery(this);
    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="i i-arrow-left"></i></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="i i-arrow-right"></i></div>',
      infinite: true
    });
  });
});

